/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InfoGraphicSaveModel } from '../../models/info-graphic-save-model';

export interface ArticlePublisherIdIdInfoGraphicLanguageIdPost$Json$Params {
  publisherId: string;
  id: string;
  languageId: string;
      body?: InfoGraphicSaveModel
}

export function articlePublisherIdIdInfoGraphicLanguageIdPost$Json(http: HttpClient, rootUrl: string, params: ArticlePublisherIdIdInfoGraphicLanguageIdPost$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, articlePublisherIdIdInfoGraphicLanguageIdPost$Json.PATH, 'post');
  if (params) {
    rb.path('publisherId', params.publisherId, {});
    rb.path('id', params.id, {});
    rb.path('languageId', params.languageId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<string>;
    })
  );
}

articlePublisherIdIdInfoGraphicLanguageIdPost$Json.PATH = '/Article/{publisherId}/{id}/InfoGraphic/{languageId}';
